import React, { useState } from "react"
import { TouchableOpacity, View } from "react-native"
import styles from "./styles"
import { OpenSansText } from "@Components/CustomText/OpenSansText"
import { RFValue } from "react-native-responsive-fontsize"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import CustomSimpleModal from "@Components/Modal/CustomSimpleModal/CustomSimpleModal"
import { Button } from "@Components/CustomButton/Button"
import { ForumService } from "@Services/Knowledge/SavoirEtre/Forum.Service"
import { ShowToast } from "@Components/ToastNotification/ToastNotification"

const ReportMessageModal = (props) => {
    const { isModalVisible, toggleModal, messageId } = props
    const [reporting, setReporting] = useState(false)
    const handleReportMessage = () => {
        setReporting(true)
        ForumService.reportMessage()
            .then(() => {
                ShowToast({
                    type: "success",
                    message: "Opération réussie."
                })
                toggleModal()
                setReporting(false)
            })
            .catch(() => {
                ShowToast({
                    type: "error",
                    message: "Une erreur est survenue."
                })
                setReporting(false)
            })
    }

    return (
        <CustomSimpleModal title={"Signaler un commentaire"} open={isModalVisible} toggleModal={toggleModal}>
            <OpenSansText
                style={{ color: baseColors.black, textAlign: "center", marginBottom: RFValue(18) }}
                defaultFontFamily={baseFontFamily.OpenSansRegular}
                fontSize={RFValue(16)}
            >
                Notre équipe de modération va être alertée par votre signalement et va procéder à une vérification.
            </OpenSansText>
            <View style={styles.btn}>
                <Button
                    loading={reporting}
                    disabled={reporting}
                    onPress={handleReportMessage}
                    text="Confirmer"
                    width="50%"
                    height={RFValue(50)}
                    backgroundColor={baseColors.green.primary}
                    labelColor={"white"}
                />
                <TouchableOpacity onPress={toggleModal}>
                    <OpenSansText
                        style={styles.cancel}
                        defaultFontFamily={baseFontFamily.OpenSansBold}
                        fontSize={RFValue(16)}
                    >
                        Annuler
                    </OpenSansText>
                </TouchableOpacity>
            </View>
        </CustomSimpleModal>
    )
}

export default ReportMessageModal
